import * as Sentry from '@sentry/react';

/**
 * Minimal error tracking. Initializes Sentry ONLY when a DSN is provided via
 * VITE_SENTRY_DSN — so local dev and any environment without the var configured
 * are completely unaffected (no network calls, no overhead, safe no-op).
 *
 * The DSN is a public client-side value (like the Supabase anon key) — it only
 * allows *sending* events, not reading them — so it's safe to expose in the
 * bundle. Still read from env so different environments can point at different
 * Sentry projects (or disable it entirely by leaving it unset).
 *
 * Scope kept intentionally small for now (error capture only): no performance
 * tracing, no session replay. Those can be enabled later if wanted.
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return; // not configured -> do nothing

  Sentry.init({
    dsn,
    // Distinguish dev vs prod events in the Sentry dashboard.
    environment: import.meta.env.MODE,
    // Error capture only for now — no perf/replay sampling.
    tracesSampleRate: 0,
    // Don't spam the project with errors while developing locally.
    enabled: import.meta.env.PROD,
  });
}

// Re-export so callers can manually capture if needed (e.g. caught errors).
export { Sentry };
